import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import LdsBlockSteps from "../../components/LdsBlockSteps";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_0 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">
            4.0.0 The 5 Steps for reading Amyvid pet scans
          </h1>
          <p className="mt-3">Estimated time to complete: 1 minute</p>
        </section>
        {/* <section>
            <h2 className="h5 b mt-4">
              MIM Referring Setup Instructions
            </h2>
            <div className="row mb-5 mt-4">
              <div className="col-sm-12 col-md-10 offset-md-1">
                <div className="row">
                  <div className="col text-center ps-4 pe-4">
                    <div className="conatiner-400 pt-3 pb-3" style={{ border: 'solid 1px' }}>
                      <p className="h3 b black">
                        STEP
                        <br />
                        <span className="h1 b">1</span>
                      </p>
                      <div className="icon-box-400-1 d-flex align-items-center justify-content-center">

                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_634_27146)">
                            <path d="M28 16C28 9.375 22.625 4 16 4V28C22.625 28 28 22.625 28 16ZM0 16C0 11.7565 1.68571 7.68687 4.68629 4.68629C7.68687 1.68571 11.7565 0 16 0C20.2435 0 24.3131 1.68571 27.3137 4.68629C30.3143 7.68687 32 11.7565 32 16C32 20.2435 30.3143 24.3131 27.3137 27.3137C24.3131 30.3143 20.2435 32 16 32C11.7565 32 7.68687 30.3143 4.68629 27.3137C1.68571 24.3131 0 20.2435 0 16Z" fill="white" />
                          </g>
                          <defs>
                            <clipPath id="clip0_634_27146">
                              <rect width="32" height="32" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>

                      </div>
                      <p className="mt-5 mb-5 ps-2 pe-2 b">Choose the black-white scale</p>
                    </div>
                  </div>
                  <div className="col ps-4 pe-4 text-center">
                    <div className="conatiner-400 pt-3 pb-3" style={{ border: 'solid 1px' }}>
                      <p className="h3 b black">
                        STEP
                        <br />
                        <span className="h1 b orange">2</span>
                      </p>
                      <div className="icon-box-400-2 d-flex align-items-center justify-content-center">

                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M16 7.25C15.138 7.25 14.3114 6.90759 13.7019 6.2981C13.0924 5.6886 12.75 4.86195 12.75 4C12.75 3.13805 13.0924 2.3114 13.7019 1.7019C14.3114 1.09241 15.138 0.75 16 0.75C16.862 0.75 17.6886 1.09241 18.2981 1.7019C18.9076 2.3114 19.25 3.13805 19.25 4C19.25 4.86195 18.9076 5.6886 18.2981 6.2981C17.6886 6.90759 16.862 7.25 16 7.25ZM16 30C15.4696 30 14.9609 29.7893 14.5858 29.4142C14.2107 29.0391 14 28.5304 14 28C14 27.4696 14.2107 26.9609 14.5858 26.5858C14.9609 26.2107 15.4696 26 16 26C16.5304 26 17.0391 26.2107 17.4142 26.5858C17.7893 26.9609 18 27.4696 18 28C18 28.5304 17.7893 29.0391 17.4142 29.4142C17.0391 29.7893 16.5304 30 16 30ZM28 18C27.4696 18 26.9609 17.7893 26.5858 17.4142C26.2107 17.0391 26 16.5304 26 16C26 15.4696 26.2107 14.9609 26.5858 14.5858C26.9609 14.2107 27.4696 14 28 14C28.5304 14 29.0391 14.2107 29.4142 14.5858C29.7893 14.9609 30 15.4696 30 16C30 16.5304 29.7893 17.0391 29.4142 17.4142C29.0391 17.7893 28.5304 18 28 18ZM2 16C2 15.4696 2.21071 14.9609 2.58579 14.5858C2.96086 14.2107 3.46957 14 4 14C4.53043 14 5.03914 14.2107 5.41421 14.5858C5.78929 14.9609 6 15.4696 6 16C6 16.5304 5.78929 17.0391 5.41421 17.4142C5.03914 17.7893 4.53043 18 4 18C3.46957 18 2.96086 17.7893 2.58579 17.4142C2.21071 17.0391 2 16.5304 2 16ZM26.9625 9.9875C26.3061 10.6439 25.4158 11.0127 24.4875 11.0127C23.5592 11.0127 22.6689 10.6439 22.0125 9.9875C21.3561 9.33109 20.9873 8.4408 20.9873 7.5125C20.9873 6.58419 21.3561 5.69391 22.0125 5.0375C22.3375 4.71248 22.7234 4.45466 23.148 4.27876C23.5727 4.10286 24.0278 4.01232 24.4875 4.01232C24.9471 4.01232 25.4023 4.10286 25.827 4.27876C26.2516 4.45466 26.6375 4.71248 26.9625 5.0375C27.2875 5.36252 27.5453 5.74838 27.7212 6.17304C27.8971 6.5977 27.9877 7.05285 27.9877 7.5125C27.9877 7.97215 27.8971 8.4273 27.7212 8.85196C27.5453 9.27662 27.2875 9.66248 26.9625 9.9875ZM6.1 25.9C5.9141 25.7141 5.76663 25.4934 5.66602 25.2505C5.56541 25.0076 5.51363 24.7473 5.51363 24.4844C5.51363 24.2215 5.56541 23.9611 5.66602 23.7182C5.76663 23.4754 5.9141 23.2547 6.1 23.0688C6.2859 22.8828 6.5066 22.7354 6.74949 22.6348C6.99239 22.5342 7.25272 22.4824 7.51562 22.4824C7.77853 22.4824 8.03886 22.5342 8.28176 22.6348C8.52465 22.7354 8.74535 22.8828 8.93125 23.0688C9.11715 23.2547 9.26462 23.4754 9.36523 23.7182C9.46584 23.9611 9.51762 24.2215 9.51762 24.4844C9.51762 24.7473 9.46584 25.0076 9.36523 25.2505C9.26462 25.4934 9.11715 25.7141 8.93125 25.9C8.74535 26.0859 8.52465 26.2334 8.28176 26.334C8.03886 26.4346 7.77853 26.4864 7.51562 26.4864C7.25272 26.4864 6.99239 26.4346 6.74949 26.334C6.5066 26.2334 6.2859 26.0859 6.1 25.9ZM23.0688 25.9C22.8828 25.7141 22.7354 25.4934 22.6348 25.2505C22.5342 25.0076 22.4824 24.7473 22.4824 24.4844C22.4824 24.2215 22.5342 23.9611 22.6348 23.7182C22.7354 23.4754 22.8828 23.2547 23.0688 23.0688C23.2547 22.8828 23.4754 22.7354 23.7182 22.6348C23.9611 22.5342 24.2215 22.4824 24.4844 22.4824C24.7473 22.4824 25.0076 22.5342 25.2505 22.6348C25.4934 22.7354 25.7141 22.8828 25.9 23.0688C26.0859 23.2547 26.2334 23.4754 26.334 23.7182C26.4346 23.9611 26.4864 24.2215 26.4864 24.4844C26.4864 24.7473 26.4346 25.0076 26.334 25.2505C26.2334 25.4934 26.0859 25.7141 25.9 25.9C25.7141 26.0859 25.4934 26.2334 25.2505 26.334C25.0076 26.4346 24.7473 26.4864 24.4844 26.4864C24.2215 26.4864 23.9611 26.4346 23.7182 26.334C23.4754 26.2334 23.2547 26.0859 23.0688 25.9ZM5.39375 5.39375C5.6724 5.1151 6.0032 4.89407 6.36727 4.74326C6.73135 4.59246 7.12156 4.51484 7.51562 4.51484C7.90969 4.51484 8.2999 4.59246 8.66398 4.74326C9.02805 4.89407 9.35885 5.1151 9.6375 5.39375C9.91615 5.6724 10.1372 6.0032 10.288 6.36727C10.4388 6.73135 10.5164 7.12156 10.5164 7.51562C10.5164 7.90969 10.4388 8.2999 10.288 8.66398C10.1372 9.02805 9.91615 9.35885 9.6375 9.6375C9.35885 9.91615 9.02805 10.1372 8.66398 10.288C8.2999 10.4388 7.90969 10.5164 7.51562 10.5164C7.12156 10.5164 6.73135 10.4388 6.36727 10.288C6.0032 10.1372 5.6724 9.91615 5.39375 9.6375C5.1151 9.35885 4.89407 9.02805 4.74326 8.66398C4.59246 8.2999 4.51484 7.90969 4.51484 7.51562C4.51484 7.12156 4.59246 6.73135 4.74326 6.36727C4.89407 6.0032 5.1151 5.6724 5.39375 5.39375Z" fill="white" />
                        </svg>

                      </div>
                      <p className="mt-5 mb-5 ps-2 pe-2 b">Set the maximum intensity of the scale to the maximum intensity of all the brain pixels</p>
                    </div>
                  </div>
                  <div className="col ps-4 pe-4 text-center">
                    <div className="conatiner-400 pt-3 pb-3" style={{ border: 'solid 1px' }}>
                      <p className="h3 b black">
                        STEP
                        <br />
                        <span className="h1 b gray">3</span>
                      </p>
                      <div className="icon-box-400-3 d-flex align-items-center justify-content-center">

                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_634_27162)">
                            <path d="M22 0C20.8937 0 20 0.89375 20 2C20 3.10625 20.8937 4 22 4H25.1688L18.5875 10.5875C17.8062 11.3687 17.8062 12.6375 18.5875 13.4187C19.3687 14.2 20.6375 14.2 21.4188 13.4187L28 6.83125V10C28 11.1062 28.8937 12 30 12C31.1063 12 32 11.1062 32 10V2C32 0.89375 31.1063 0 30 0H22ZM13.4125 18.5875C12.6313 17.8062 11.3625 17.8062 10.5813 18.5875L4 25.1688V22C4 20.8937 3.10625 20 2 20C0.89375 20 0 20.8937 0 22V30C0 31.1063 0.89375 32 2 32H10C11.1062 32 12 31.1063 12 30C12 28.8937 11.1062 28 10 28H6.83125L13.4125 21.4125C14.1938 20.6313 14.1938 19.3625 13.4125 18.5812V18.5875Z" fill="white" />
                          </g>
                          <defs>
                            <clipPath id="clip0_634_27162">
                              <rect width="32" height="32" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>

                      </div>
                      <p className="mt-5 mb-5 ps-2 pe-2 b">Ensure optimum size of images</p>
                    </div>
                  </div>
                  <div className="col ps-4 pe-4 text-center">
                    <div className="conatiner-400 pt-3 pb-3" style={{ border: 'solid 1px' }}>
                      <p className="h3 b black">
                        STEP
                        <br />
                        <span className="h1 b">4</span>
                      </p>
                      <div className="icon-box-400-4 d-flex align-items-center justify-content-center">

                        <svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_634_27170)">
                            <path d="M0 4C0 1.79375 1.79375 0 4 0H20C22.2062 0 24 1.79375 24 4V28C24 30.2062 22.2062 32 20 32H4C1.79375 32 0 30.2062 0 28V4ZM4 9C4 9.55 4.45 10 5 10H19C19.55 10 20 9.55 20 9C20 8.45 19.55 8 19 8H5C4.45 8 4 8.45 4 9ZM5 14C4.45 14 4 14.45 4 15C4 15.55 4.45 16 5 16H19C19.55 16 20 15.55 20 15C20 14.45 19.55 14 19 14H5ZM5 20C4.45 20 4 20.45 4 21C4 21.55 4.45 22 5 22H13C13.55 22 14 21.55 14 21C14 20.45 13.55 20 13 20H5Z" fill="white" />
                          </g>
                          <defs>
                            <clipPath id="clip0_634_27170">
                              <rect width="24" height="32" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>

                      </div>
                      <p className="mt-5 mb-5 ps-2 pe-2 b">Review every transverse image </p>
                    </div>
                  </div>
                  <div className="col ps-4 pe-4 text-center">
                    <div className="conatiner-400 pt-3 pb-3" style={{ border: 'solid 1px' }}>
                      <p className="h3 b black">
                        STEP
                        <br />
                        <span className="h1 b gray">5</span>
                      </p>
                      <div className="icon-box-400-5 d-flex align-items-center justify-content-center">

                        <svg width="37" height="32" viewBox="0 0 37 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_634_26473)">
                            <path d="M0.28125 16C0.28125 10.475 4.75625 6 10.2812 6H14.2812C15.3875 6 16.2812 6.89375 16.2812 8C16.2812 9.10625 15.3875 10 14.2812 10H10.2812C6.96875 10 4.28125 12.6875 4.28125 16C4.28125 19.3125 6.96875 22 10.2812 22H14.2812C15.3875 22 16.2812 22.8937 16.2812 24C16.2812 25.1063 15.3875 26 14.2812 26H10.2812C4.75625 26 0.28125 21.525 0.28125 16ZM36.2812 16C36.2812 21.525 31.8062 26 26.2812 26H22.2812C21.175 26 20.2812 25.1063 20.2812 24C20.2812 22.8937 21.175 22 22.2812 22H26.2812C29.5938 22 32.2812 19.3125 32.2812 16C32.2812 12.6875 29.5938 10 26.2812 10H22.2812C21.175 10 20.2812 9.10625 20.2812 8C20.2812 6.89375 21.175 6 22.2812 6H26.2812C31.8062 6 36.2812 10.475 36.2812 16ZM12.2812 14H24.2812C25.3875 14 26.2812 14.8938 26.2812 16C26.2812 17.1062 25.3875 18 24.2812 18H12.2812C11.175 18 10.2812 17.1062 10.2812 16C10.2812 14.8938 11.175 14 12.2812 14Z" fill="white" />
                          </g>
                          <defs>
                            <clipPath id="clip0_634_26473">
                              <rect width="36" height="32" fill="white" transform="translate(0.28125)" />
                            </clipPath>
                          </defs>
                        </svg>

                      </div>
                      <p className="mt-5 mb-5 ps-2 pe-2 b">Determine if the scan is positive or negative</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section> */}
        <section className="row justify-content-center mt-5 mb-3">
          <div className="col-12 align-items-center">
            <LdsBlockSteps />
          </div>
        </section>
        <section className="button-control">
          <LdsButton
            classes="white-button mt-3 mb-5 prev"
            onClick={function navClick() {
              window.open("/module-4/isi", "_self");
            }}
          >
            Previous Lesson
          </LdsButton>
          <LdsButton
            classes="blue-button mt-3 mb-5 align-self-right float-end next"
            onClick={function navClick() {
              window.open("/module-4/module-4-1-0", "_self");
            }}
          >
            Next Lesson
          </LdsButton>
        </section>
      </main>
    </div>
  );
};

export default Module_1_0;
